<div class="workspace no-back-btn d-none d-sm-block">
  <div class="row">
    <div class="col-md-12 col-lg-12 tab-container">
      <div>
        <ul class="nav nav-tabs" id="myTab" [ngStyle]="{backgroundColor: platformBackground}" role="tablist">

          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isActiveUserSettingsTab}"
               data-toggle="tab"
               actionByLevels=""
               [wallName]=""
               (afterChecking)="showUserSettings()"
               (click)="showUserSettings()"
               role="tab" placement="bottom">{{ 'INFLUENCER.USER_SETTINGS' | translate }}</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isActiveSocialAccountsTab}"
               data-toggle="tab"
               actionByLevels=""
               [wallName]=""
               (click)="showSocialAccounts()"
               role="tab" placement="bottom">{{ 'INFLUENCER.SOCIAL_ACCOUNTS' | translate }}</a>
          </li>

        </ul>
        <div class="tab-content" >

          <div *ngIf="isActiveUserSettingsTab">
            <form #influencerSettingForm="ngForm" class="influencer-settings-form" (ngSubmit)="updateSetting()">
              <div class="hr"></div>

              <div class="row">
                <div class="col-md-8">

                  <div class="row">
                    <div class="user-info-col-left col-md-6">
                      <div class="form-group">
                        <label>{{'INFLUENCER.labels.first_name' | translate}}</label>
                        <achoo-text-field
                          placeholder="{{'influencer_settings.form.placeholder.name' | translate}}"
                          [(model)]="influencerSetting.first_name"
                          name="name"
                        ></achoo-text-field>
                      </div>
                      <div class="form-group">
                        <label>{{'INFLUENCER.labels.email' | translate}}</label>
                        <achoo-text-field
                          placeholder="{{'influencer_settings.form.placeholder.email' | translate}}"
                          [(model)]="influencerSetting.email"
                          name="email"
                        ></achoo-text-field>
                      </div>
                      <div class="form-group">
                        <label>{{'INFLUENCER.labels.phone_number' | translate}}</label>
                        <achoo-text-field
                          placeholder="{{ 'influencer_settings.form.placeholder.phone' | translate}}"
                          [(model)]="influencerSetting.phone"
                          [isTelephoneField]="true"
                          name="phone"
                        ></achoo-text-field>
                      </div>
                    </div>

                    <div class="user-info-col-right col-md-6">
                      <div class="form-group">
                        <label>{{'INFLUENCER.labels.last_name' | translate}}</label>
                        <achoo-text-field
                            placeholder="{{ 'influencer_settings.form.placeholder.last_name' | translate}}"
                            [(model)]="influencerSetting.last_name"
                            name="last_name"
                        ></achoo-text-field>
                      </div>
                      <div class="form-group">
                        <label>{{'INFLUENCER.labels.rewrite_email' | translate}}</label>
                        <achoo-text-field
                          placeholder="{{'influencer_settings.form.placeholder.email' | translate}}"
                          [(model)]="influencerSetting.rewrite_email"
                          name="rewrite_email"
                        ></achoo-text-field>
                      </div>
                    </div>
                  </div>

                </div>


                <div class="col-md-4">
                  <div class="user-profile-image">
                    <div class="profile-image">
                      <img src={{userAvatar}} alt="">
                    </div>
                    <p>{{'INFLUENCER.labels.profile_picture' | translate}}</p>
                    <div class="btn-file">
                      {{'INFLUENCER.labels.upload_image' | translate}}
                      <input type="file" name="file" (change)="onUserAvatarSelected($event)" />
                    </div>
                  </div>
                </div>

              </div>

              <div class="hr fix-password-border"></div>
              <div class="row">
                <div class="col-md-8">
                  <div class="row">
                    <div class="heading">{{'INFLUENCER.labels.password' | translate}}</div>

                    <div class="user-info-col-left col-md-6">
                      <div class="form-group">
                        <label>{{'INFLUENCER.labels.old_password' | translate}}</label>
                        <achoo-text-field
                          [(model)]="influencerSetting.old_password"
                          [isPasswordField]="true"
                          name="old_password"
                        ></achoo-text-field>
                      </div>

                      <div class="form-group">
                        <label>{{'INFLUENCER.labels.new_password' | translate}}</label>
                        <achoo-text-field
                          [(model)]="influencerSetting.new_password"
                          [isPasswordField]="true"
                          name="new_password"
                        ></achoo-text-field>
                      </div>
                    </div>

                    <div class="user-info-col-right col-md-6">
                      <div class="form-group bottom">
                        <label>{{'INFLUENCER.labels.repeat_new_password' | translate}}</label>
                        <achoo-text-field
                          [(model)]="influencerSetting.repeat_new_password"
                          [isPasswordField]="true"
                          name="repeat_new_password"
                        ></achoo-text-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div *ngIf="isActiveSocialAccountsTab">

            <div class="hr"></div>

            <div class="d-flex flex-column align-items-center">
              <div>
                <div *ngFor="let error of channelErrors" class="d-flex form-error">
                  <p class="error" role="alert" [innerHTML]="error.message | translate"></p>
                </div>
                <div class="heading-account">{{'INFLUENCER.labels.account_name' | translate}}</div>
                <div class="social-account-list" *ngFor="let channel of listChannel">
                  <platform-field [channelData]="channel"
                                  (modifyChannelResponse)="onModifyChannel($event)"
                                  (authorizeClick)="authorizeChannel($event)"
                                  (deleteClick)="onDeleteChannel($event)"
                                  (handleChange)="onChangeHandle($event)">
                  </platform-field>
                </div>

                <div class="btn-add-channel" >
                  {{'INFLUENCER.labels.add_channel' | translate}}
                  <achoo-filter-box
                    [options]="platforms"
                    [(model)]="selectedChannels"
                    placement="bottom"
                    [disabled]="numberOfAddedChannels >= maxChannelCanAdded"
                    (selectEvent)="afterChangePlatform($event)">
                  </achoo-filter-box>
                </div>
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>
  </div>
</div>



<div class="mobile-workspace">
  <div class="d-flex flex-column align-items-center">
    <div class="mobile-user-profile-image d-flex flex-column align-items-center">
      <div class="profile-image">
        <img src="{{userAvatar}}" alt="">
      </div>
      <div class="btn-file">
        {{'INFLUENCER.labels.change_profile_photo' | translate}}
        <input type="file" name="file" (change)="onUserAvatarSelected($event)" />
      </div>
    </div>
  </div>

  <div>
    <div class="tab-heading">{{'INFLUENCER.SOCIAL_ACCOUNTS' | translate}}</div>
    <div>
      <div *ngFor="let error of channelErrors" class="d-flex form-error">
        <p class="error" role="alert" [innerHTML]="error.message | translate"></p>
      </div>
      <button class="btn-add-channel" (click)="addChannel()">{{'INFLUENCER.labels.add_channel' | translate}}</button>
      <div class="social-account-list" *ngFor="let channel of listChannel">
        <platform-field [channelData]="channel"
                        (modifyChannelResponse)="onModifyChannel($event)"
                        (authorizeClick)="authorizeChannel($event)"
                        (deleteClick)="onDeleteChannel($event)"
                        (handleChange)="onChangeHandle($event)"></platform-field>
      </div>
    </div>
  </div>

  <div>
    <form #influencerSettingFormMobile="ngForm" class="influencer-settings-mobile-form" (ngSubmit)="updateSetting()">
    <div>
      <div class="tab-heading">{{'INFLUENCER.labels.your_user_settings' | translate}}</div>
      <div class="form-group">
        <label>{{'INFLUENCER.labels.first_name' | translate}}</label>
        <achoo-text-field
          placeholder="{{'influencer_settings.form.placeholder.name' | translate}}"
          [(model)]="influencerSetting.first_name"
          [id]="'mobile-influencer-name'"
          name="name"
        ></achoo-text-field>
      </div>
      <div class="form-group">
        <label>{{'INFLUENCER.labels.last_name' | translate}}</label>
        <achoo-text-field
          placeholder="{{ 'influencer_settings.form.placeholder.last_name' | translate}}"
          [(model)]="influencerSetting.last_name"
          [id]="'mobile-influencer-last-name'"
          name="last_name"
        ></achoo-text-field>
      </div>
      <div class="form-group">
        <label>{{'INFLUENCER.labels.email' | translate}}</label>
        <achoo-text-field
          placeholder="{{'influencer_settings.form.placeholder.email' | translate}}"
          [(model)]="influencerSetting.email"
          [id]="'mobile-influencer-email'"
          name="email"
        ></achoo-text-field>
      </div>

      <div class="form-group">
        <label>{{'INFLUENCER.labels.phone_number' | translate}}</label>
        <achoo-text-field
          placeholder="{{ 'influencer_settings.form.placeholder.phone' | translate}}"
          [isTelephoneField]="true"
          [(model)]="influencerSetting.phone"
          [id]="'mobile-influencer-phone'"
          name="phone"
        ></achoo-text-field>
      </div>

      <div class="tab-heading">{{'INFLUENCER.labels.password' | translate}}</div>

      <div class="form-group">
        <label>{{'INFLUENCER.labels.old_password' | translate}}</label>
        <achoo-text-field
          [(model)]="influencerSetting.old_password"
          [isPasswordField]="true"
          name="old_password"
          [id]="'mobile-influencer-oldpass'"
        ></achoo-text-field>
      </div>

      <div class="form-group">
        <label>{{'INFLUENCER.labels.new_password' | translate}}</label>
        <achoo-text-field
          [(model)]="influencerSetting.new_password"
          [isPasswordField]="true"
          name="new_password"
          id="mobile-influencer-newpass"
        ></achoo-text-field>
      </div>
      <div class="form-group bottom">
        <label>{{'INFLUENCER.labels.repeat_new_password' | translate}}</label>
        <achoo-text-field
          [(model)]="influencerSetting.repeat_new_password"
          [isPasswordField]="true"
          name="repeat_new_password"
          id="mobile-influencer-repeatpass"
        ></achoo-text-field>
      </div>
    </div>
    </form>
  </div>
</div>

<div class="group-bottombar bottombar" [ngClass]="{'open': activeBottomBar === true, 'collapsed': activeBottomBar === false}">
  <div class="buttons d-flex flex-auto" *ngIf="!activeBottomBar">
    <button class="button red back" (click)="back()">{{'common.btn.back' | translate}}</button>
    <div *ngIf="isActiveUserSettingsTab">
      <button class="button green" (click)="updateSetting()">{{'common.btn.save' | translate}}</button>
    </div>
  </div>

  <div class="row full-height" *ngIf="activeBottomBar">
    <div class="col-md-12 col-sm-12">
      <add-script-blog
        [blogChannel]="blogChannel"
        (finishAddingScript)="authorizeBlog()"
        (closeAddScriptBox)="hideSettingAuthorizeBlogBox()"
      ></add-script-blog>
    </div>
  </div>

</div>

<achoo-modal #AlertAuthorizeFail>
  <div class="auth-alert-dialog auth-fails">
    <div class="dlg-body danger">
      <span>{{'INFLUENCER.channel_auth_fail_msg' | translate}}</span>
    </div>
    <div class="dlg-buttons d-flex justify-content-end align-items-center">
      <button (click)="onClose()" type="button" class="button red">{{'common.btn.close' | translate}}</button>
    </div>
  </div>
</achoo-modal>

<achoo-popup #AlertRemoveSocial
             cancelBtnLabel="{{'common.btn.cancel' | translate}}"
             acceptBtnLabel="{{'common.btn.remove' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="acceptDeleteChannel()"
             (cancelCallback)="onClose()">
  <div class="d-flex flex-column flex-auto">
    <span>{{'INFLUENCER.channel_remove_social' | translate}}</span>
  </div>
</achoo-popup>

<achoo-modal #AlertRemoveSocialMobile>
  <div class="auth-alert-dialog">
    <div class="dlg-body">
      <span>{{'INFLUENCER.channel_remove_social' | translate}}</span>
    </div>
    <div class="dlg-buttons d-flex justify-content-end align-items-center">
      <button (click)="acceptDeleteChannel()" type="button" class="button red">{{'common.btn.remove' | translate}}</button>
    </div>
  </div>
</achoo-modal>

<achoo-modal #AlertAuthorizeChannel>
  <div class="auth-alert-dialog">
    <div class="dlg-title"><span>{{'INFLUENCER.channel_information' | translate}}</span></div>
    <div class="dlg-body">
      <div class="select-chanel-box">
        <achoo-filter-box [options]="platforms"
                          [(model)]="mobileSelectedChannel"
                          (closeDropDownEvent)="afterChangePlatform($event)"
                          [placeholder]="'influencer_settings.social_platform' | translate"
                          placement="bottom">
        </achoo-filter-box>
        <div class="authorize-account" *ngIf="isSelectedChannel && !isIGChannel">
          <span>@</span>
          <achoo-text-field
            placeholder="{{ 'influencer_settings.form.placeholder.yourusername' | translate}}"
            [(model)]="authorizeAccount"
          ></achoo-text-field>
        </div>
      </div>
    </div>
    <div class="dlg-buttons d-flex justify-content-end align-items-center">
      <button (click)="closeChannelModal()" type="button" class="button red">{{'common.btn.cancel' | translate}}</button>
      <button *ngIf="isIGChannel"  type="button" class="button green btn-authorize" (click)="authorizeChannel({channel: 'ig'})">{{'common.btn.authorize_now' | translate}}</button>
      <button *ngIf="isSelectedChannel && !isIGChannel"
              type="button" [disabled]="isAddingChannel ? 'disabled': ''"
              [ngClass]="{'green': authorizeAccount, 'grey': !authorizeAccount}"
              class="button btn-authorize" (click)="addNewChannel()">{{'common.btn.add_channel' | translate}}</button>
    </div>
  </div>
</achoo-modal>
<achoo-popup #ModifyChannelNotification
             [isNotification]="true"
             modelTitle="{{notificationStatus}}">
  <div class="d-flex flex-row flex-auto">
    <span>{{notificationMessage}}</span>
  </div>
</achoo-popup>




// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/influencer-settings.component.html